var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        { staticStyle: { "flex-shrink": "0" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("w-select", {
                    attrs: { value: _vm.selectedApp, items: _vm.appItems },
                    on: {
                      input: function ($event) {
                        return _vm.onView($event)
                      },
                    },
                  }),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Stack openen",
                              expression: "'Stack openen'",
                            },
                          ],
                          attrs: { disabled: _vm.selected.length != 1 },
                          on: {
                            click: function ($event) {
                              return _vm.openStack()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "list" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.selected.length != 1 },
                          on: {
                            click: function ($event) {
                              return _vm.openCompany()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.selected.length == 0 },
                          on: {
                            click: function ($event) {
                              return _vm.deleteLogs()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Alle logs verwijderen voor datum",
                              expression: "'Alle logs verwijderen voor datum'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.purgeLogsOlderThenDateData.open = true
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "purge-button" },
                            [
                              _c("w-fa", { attrs: { icon: "trash" } }),
                              _c("w-fa", { attrs: { icon: "clock" } }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Alle logs verwijderen",
                              expression: "'Alle logs verwijderen'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.purgeLogs()
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "purge-button" },
                            [
                              _c("w-fa", { attrs: { icon: "trash" } }),
                              _c("w-fa", { attrs: { icon: "minus-circle" } }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-log-data-table", {
        attrs: {
          logs: _vm.logs,
          selected: _vm.selected,
          order: _vm.orderColumn,
          "order-ascending": _vm.ascending,
        },
        on: {
          order: function ($event) {
            return _vm.onOrder($event)
          },
          "open-log": function ($event) {
            return _vm.openCompany($event)
          },
        },
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-browse-pagination", {
                attrs: {
                  limit: _vm.limit,
                  page: _vm.page,
                  records: _vm.records,
                },
                on: {
                  limit: function ($event) {
                    return _vm.onLimitChange($event)
                  },
                  page: function ($event) {
                    return _vm.onNewPage($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.openedStack != null } },
        [
          _vm.openedStack
            ? _c(
                "w-card",
                { attrs: { "max-width": "900" } },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.openedStack.message) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeStack()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-card-content" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            _vm._l(
                              _vm.openedStackMessageLines,
                              function (line, i) {
                                return _c("div", { key: i }, [
                                  _vm._v(_vm._s(line)),
                                ])
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.purgeLogsOlderThenDateData.open
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [_vm._v("Logs verwijderen")]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-date-picker", {
                                attrs: {
                                  label: "Logs verwijderen voor deze datum",
                                },
                                model: {
                                  value: _vm.purgeLogsOlderThenDateData.date,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.purgeLogsOlderThenDateData,
                                      "date",
                                      $$v
                                    )
                                  },
                                  expression: "purgeLogsOlderThenDateData.date",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              _vm.purgeLogsOlderThenDateData.open = false
                            },
                          },
                        },
                        [_vm._v("Annuleren")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.purgeLogsOlderThenDate()
                            },
                          },
                        },
                        [_vm._v("Bevestigen")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }